import {Origin} from "./../../models/Origin";

let originsApi = {
    async get(token, companyId, params={}){
        let response = await window.axios.get('/api/origins', {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data;
    },
    async create(origin, token, companyId){
        let response = await window.axios.post('/api/origins', origin, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Origin(response.data);
    },
    async edit(origin, token, companyId){
        let response = await window.axios.put('/api/origins/'+origin.id, origin, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Origin(response.data);
    },
    async delete(origin, token, companyId){
        let response = await window.axios.delete('/api/origins/'+origin.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    },
}

export default originsApi